<template>
  <modal width="50" :show-modal="showModal" @close-modal="$emit('close-modal')" :showTitle="false"
    :styleContent="{ padding: '0' }">
    <div class="p-4 relative">
      <button class="close_btn" @click="closeModal">&#x2715;</button>
      <b class="block w-full mb-0 pt-0 font-semibold text-lg">Dispatcher Ratings</b>
      <div class="flex flex-wrap justify-center mt-5">
        <div class="img_wrapper">
          <img :src="driverImg" alt="" class="image_url" />
          <b class="block w-full text-center">{{ driverName }}</b>
        </div>
        <div class="w-full flex justify-center flex-wrap">
          <p class="packg_uppdate">Awesome, your package has just been delivered! Rate your dispatcher.</p>
          <div class="w-full flex justify-center">
            <div class="pt-3 pb-3">
              <star-rate :canChange="true" :onChange="getRate" :size="35"></star-rate>
            </div>
          </div>

          <div class="flex justify-center">
            <div class="rate_item_wrapper">
              <button @click="starValue = item" :class="`rate_item ${item === starValue && 'active'}`"
                v-for="item in startContents" :key="item">{{ item
                }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="py-3 flex mt-6">
        <div class="w-full">
          <label class="text-gray-400">Comments</label>
          <textarea class="w-full bg-gray-200 resize-none p-3 mt-0 h-48 rounded"
            placeholder="Start typing your comments here…" v-model="comment"></textarea>
        </div>
      </div>
      <div class="flex justify-between items-center py-3 mt-12">
        <button @click="$emit('close-modal')">Cancel</button>
        <primary-button :disabled="!canSubmit" @click="submitRatings" class="shadow-md font-normal" buttonText="Submit"
          :loading="loading" />
      </div>
      <AcknowledgeRating :showModal="hasSubmit" @close-modal="hasSubmit = false" />
    </div>
  </modal>
</template>

<script>
import AcknowledgeRating from "@/components/Ondemand/Bookings/modals/AcknowledgeRating.vue";

export default {
  props: {
    showModal: {
      required: true,
      default: false,
    },
  },
  components: {
    AcknowledgeRating
  },
  watch: {
    rate() {
      this.starValue = null
    },
    showModal(val) {
      if (val) {
        setTimeout(() => {
          this.getRate(1)
          this.rate = 1
        }, 500)
        this.driver = this.$store.getters?.getRatingsBooking?.driver;
      } else {
        this.rate = null;
        this.starValue = null
      }
    }
  },
  data() {
    return {
      reason: "",
      isTip: false,
      hasSubmit: false,
      rate: null,
      option: '',
      comment: "",
      driver: {},
      showIssuesDropDown: true,
      loading: false,
      starValue: null,
      starContent: {
        star_2: [
          "Delivered late",
          "Package  Damaged",
          "Wrong package",
          "Safety concern",
          "Unprofessional",
          "Incomplete delivery",
        ],
        star_3: [
          "Delivered late",
          "Package  Damaged",
          "Wrong package",
          "Safety concern",
          "Unprofessional",
          "Incomplete delivery",
        ]
      },
    };
  },
  computed: {
    canShowComment() {
      return this.starValue == 'others' || this.rate >= 4
    },
    driverName() {
      return `${this.driver?.first_name || this.driver?.firstname} ${this.driver?.last_name || this.driver?.lastname}`
    },
    driverImg() {
      return this.driver?.imageurl
    },
    canSubmit() {
      return this.rate != null &&
        this.$store.getters?.getRatingsBooking?.driver?.id &&
        (
          (this.starValue != null && this.rate <= 3) ||
          (this.starValue == null && this.rate > 3)
        )
    },
    startContents() {
      switch (this.rate) {
        case 1:
          return this.starContent.star_2;

        case 2:
          return this.starContent.star_2;

        case 3:
          return this.starContent.star_3;

        default:
          return []
      }
    },
    payload() {
      return {
        ratedUserId: this.$store.getters?.getRatingsBooking?.driver?.id,
        tags: this.starValue ? [this.starValue] : undefined,
        shippingId: this.$store.getters?.getRatingsBooking.id,
        rating: this.rate,
        reason: this.option,
        comment: this.comment
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    getRate(val) {
      Number(val) == 5 ? (this.showIssuesDropDown = false) : (this.showIssuesDropDown = true);
      this.rate = val
    },
    async submitRatings() {
      this.loading = true;
      try {
        await this.$_submitRating(this.payload);
        this.hasSubmit = true
        this.closeModal();
        this.$emit('success')
      } catch (error) {
        this.generateToast(error?.response?.data?.error);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.close_btn {
  @apply absolute top-2 right-2 w-[20px] h-[20px] border border-red-500 text-red-500 z-10 inline-flex justify-center items-center rounded-full text-[12px]
}

.rate_item_wrapper {
  @apply flex justify-center flex-wrap gap-3 max-w-[600px] mt-2;
}

.rate_item {
  @apply bg-gray-100 rounded-2xl px-3 py-1 text-sm;

  &.active {
    @apply bg-primary-yellow;
  }
}

.packg_uppdate {
  @apply w-full px-2 text-center max-w-[400px]
}

.tips {
  @apply inline-block rounded border border-gray-100 py-2 px-3 mr-2 cursor-pointer
}

.image_url {
  @apply mb-2 rounded-full h-[120px] w-[120px] object-cover
}

.img_wrapper {
  @apply w-[120px] mr-4 flex justify-center flex-wrap mb-4
}
</style>
